import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const QrCodePage = () => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;
    const [searchParams] = useSearchParams();
    const enWord = searchParams.get("en");
    const arWord = searchParams.get("ar");
    const word = { en: enWord, ar: arWord };
    const hasWord = Boolean(enWord?.trim() || arWord?.trim());

    return (
        <div className="h-full w-full flex flex-col justify-center items-center bg-primary-ivory 2xl:py-[3vw] xl:py-12 lg:py-10 md:py-8 py-6 2xl:px-[2vw] xl:px-8 lg:px-6 md:px-4 px-3 overflow-hidden pt-40!">
            <div className="w-full max-w-2xl flex flex-col items-center shrink-0">
                <h1 className="sr-only">{t("qrCode.title")}</h1>
                <div className="w-full 2xl:rounded-[1.04vw] rounded-2xl 2xl:border-[0.2vw] border-2 border-black-300 bg-primary-yellow 2xl:p-[1.5vw] xl:p-6 lg:p-5 md:p-4 p-4 2xl:shadow-[0px_0.313vw_0px_#110706] shadow-[6px_6px_0px_#110706] flex flex-col items-center justify-center 2xl:gap-[1vw] xl:gap-5 md:gap-4 gap-3 text-center">
                    <p className="2xl:text-[1.2vw] xl:text-xl lg:text-lg md:text-base text-sm font-bold text-primary-rose">
                        {t("qrCode.yourWordIs")}
                    </p>
                    {hasWord ? (
                        <p
                            className="2xl:text-[2.5vw] xl:text-4xl lg:text-3xl md:text-2xl text-xl font-bold wrap-break-word max-w-full text-black-900"
                            dir="auto"
                        >
                            {word[currentLanguage as keyof typeof word]}
                        </p>
                    ) : (
                        <p className="2xl:text-[1.04vw] xl:text-base lg:text-sm md:text-sm text-xs font-medium text-black-400">
                            {t("qrCode.noWordFound")}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};
export default QrCodePage;
